// components/main/SectionContainer.tsx

import { SectionProps } from "./types";

export const SectionContainer = ({ children, id }: SectionProps) => {
  return (
    <div
      id={id}
      className="col-4 p-4 rounded-lg bg-BG-light dark:bg-BG-dark bp:dark:bg-black bp:bg-white"
    >
      {children}
    </div>
  );
};
